import React from "react";
import {
    AI_CATEGORIZATION_SCORE_DIGITS,
    AI_CATEGORIZATION_SCORE_FACTOR
} from "../../../../controllers/CategorizationReviewPageFilterController.ts";
import type {DeserializedGridCellParams} from "../../../../../../components/muix-data-grid/MuiXColumnDefinitions.ts";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {Tag} from "../../../../../../components/tag/Tag.tsx";
import type {TagColor} from "../../../../../../components/tag/tag.styles.ts";

function getScoreTagColor(score: number): TagColor {
    if (score <= 30) return 'error';
    if (score <= 50) return 'warning';
    if (score <= 70) return 'success';
    return 'info';
}

export const ScoreCell: React.FC<DeserializedGridCellParams<PartGridRowModel>> = (props) => {
    const value = props.value;
    if (!value) return <></>
    const s = Number(value) * AI_CATEGORIZATION_SCORE_FACTOR;
    const sScore = s.toFixed(AI_CATEGORIZATION_SCORE_DIGITS);
    return <Tag label={sScore} color={getScoreTagColor(s)} sx={{maxHeight: '24px'}}/>;
}
